/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { INVITE_USER } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { StorageModule } from "@vlinder-web/storage-module-react";

const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface InviteUserProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  role: string;
}
export interface IInviteUserMethods extends IPluginMethodMap {
  getInviteUser(args: InviteUserProps): Promise<any>;
}

export class InviteUserService implements IAgentPlugin {
  readonly methods: IInviteUserMethods;

  constructor() {
    this.methods = {
      getInviteUser: this.getInviteUser.bind(this),
    };
  }

  async getInviteUser(args: InviteUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        let role = storageService.get("bandConfig", "local")?.roles;
        role =
          role &&
          Array.isArray(role) &&
          role.length > 0 &&
          role.filter((r: any) => r.role === "picker");
        const res = await client.mutate({
          mutation: INVITE_USER,
          variables: {
            input: {
              invite: args?.invite,
              role:
                role && Array.isArray(role) && role.length === 1
                  ? role[0]?.uuid
                  : null,
              user: {
                email: args?.email,
                firstName: args?.firstName,
                lastName: args?.lastName,
              },
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createUser,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
